import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // On ne charge que le token au démarrage
  const [token, setToken] = useState(localStorage.getItem('token'));

  // Login : on stocke le token
  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  // Logout
  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return (
    // On passe token, login et logout à toute l'app
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);